export const IconConst = {
  DASHBOARD: "fas fa-fw fa-tachometer-alt",
  STAFF: "fa fa-users",
  USER: "fa fa-user",
  FILE: "fa fa-file",
  COMPANY: "fas fa-university",
  ASSIGNMENT: "fa fa-book",
  GROUPS: "fa fa-group",
  ROLE: "fas fa-user-tag",
  MERGE_FIELDS: "fa fa-code-fork",
  MAIL: "fa fa-envelope",
  SEND_EMAIL: "fa fa-check-square",
  MARKETING: "fa  fa-globe",
  PRODUCT: "fa fa-file-photo-o",
  PASSWORD: "fa  fa-lock",
  SHARE: "fas fa-share",

  BTN: {
    EDIT: "fa fa-edit",
    DELETE: "fa  fa-trash",
  },

  EXPORT_TO_PDF: "fas fa-file-pdf",
  EXPORT_TO_CSV: "fas fa-file-csv",
  PRINT: "fas fa-print",
  EMAIL: "fas fa-envelope",
};
